
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/[gold_silver_path]",
      function () {
        return require("private-next-pages/cleartax.in/[gold_silver_path]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/[gold_silver_path]"])
      });
    }
  